import { formatNumber } from '@angular/common';
import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { COMPANY_COUNT_CAP } from '@app/core';

/**
 * The total of a company list with thousands separators, "200,000+" when
 * the API stopped counting at its cap.
 */
@Pipe({ name: 'companyTotal', standalone: false })
export class CompanyTotalPipe implements PipeTransform {
  private locale = inject(LOCALE_ID);

  transform(total: number | null | undefined): string {
    const value = total || 0;
    const formatted = formatNumber(value, this.locale);
    return value >= COMPANY_COUNT_CAP ? `${formatted}+` : formatted;
  }
}
